import React from "react";
import ReactDOM from "react-dom";
import OutputReportAdminPlaceholder from "../../components/OutputReportAdmin/OutputReportAdminPlaceholder";
import addMainMenuItem from "./AddMainMenuItem";

const addOutputReportAdmin = () => {
    const outputReportsButtonHandler = () => {
        const contentDiv = document.getElementById('ApplicationContent');
        if (null != contentDiv) {
            contentDiv.innerHTML = "";
            // Cross-user search by party ID removed (review #8); direct admins to the
            // per-user profile page instead.
            ReactDOM.render(
                <React.StrictMode>
                    <OutputReportAdminPlaceholder />
                </React.StrictMode>,
                contentDiv
            );
        }
    }

    addMainMenuItem(5, outputReportsButtonHandler, "Output Reports");
}

export default addOutputReportAdmin;
